(function() {
    angular.module('adminApp.licenses', ['dndLists', 'smart-table']);
})();
